'use client';

import { useState } from 'react';
import { Button, Collapse } from 'antd';
import { useTranslations } from 'next-intl';

let hasRetried = false;

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const [retried, setRetried] = useState(hasRetried);
  const t = useTranslations();

  const details = [
    `Error: ${error.message ?? '(no message)'}`,
    error.digest ? `Digest: ${error.digest}` : null,
    `Time: ${new Date().toISOString()}`,
    `URL: ${typeof window !== 'undefined' ? window.location.href : ''}`,
    '',
    'Stack:',
    error.stack ?? '(no stack)',
  ]
    .filter((line) => line !== null)
    .join('\n');

  const handleAction = () => {
    if (retried) {
      hasRetried = false;
      window.location.reload();
    } else {
      hasRetried = true;
      setRetried(true);
      reset();
    }
  };

  return (
    <div>
      <h2>{t('ERROR_PAGE_TITLE')}</h2>
      <div>{t.rich('ERROR_PAGE_TEXT', { p: (chunks) => <p className="bottom-10">{chunks}</p> })}</div>
      <Collapse
        className="top-10 bottom-10"
        items={[
          {
            key: '1',
            label: t('SHOW_DETAILS'),
            children: <div style={{ display: 'block', maxHeight: 260, overflow: 'auto', whiteSpace: 'pre-wrap', fontSize: 12 }}>{details}</div>,
          },
        ]}
      />
      <Button type="primary" onClick={handleAction}>
        {t('TRY_AGAIN')}
      </Button>
    </div>
  );
}
